<script>
    import {fade} from 'svelte/transition';
    export let color = '#FFCC33';
    export let source='/images/opus_logoblack.svg';
</script>

<section>
    <div class="maindiv" style="--color:{color}">

        {#if source==='/images/opus_logoblack.svg'}
        <div class="image">
            <img
                src={source}
                height="100%"
                width="100%"
                alt=""
            />
        </div>
        {:else}
        <div class="image" in:fade="{{duration: 500, delay: 300}}">
            <img
                src={source}
                height="100%"
                width="100%"
                alt=""
            />
        </div>
        {/if}        
    </div>
</section>

<style>
    .maindiv {
        position: fixed;
        left: -0.99vw;
        top: 2.083vw;
        width: 9.271vw;
        height: 3.854vw;
        background-color: var(--color);
        border-radius: 0.521vw;
        z-index: 5;
    }
    .image {
        width: 5.365vw;
        height: 1.667vw;
        position: absolute;
        left: 2.865vw;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
    }
</style>
